module.exports = __webpack_public_path__ + "media/images/list-8b75682919abe740e8e166a77757f3f0.webp";